import axios from "axios";
import config from "@/config/env.config.json";
import logger from "@/utils/logger";

const envConfig = config[process.env.NODE_ENV];
const consumerBaseUrl = envConfig.consumerApiBaseUrl;
const userProfilesApi = {};

userProfilesApi.getById = async (id) => {
  try {
    const response = await axios.get(`${consumerBaseUrl}/user_profiles/${id}`);
    logger.info(response.data);
    return response.data;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};

userProfilesApi.getUsersDevices = async (userProfileId) => {
  try {
    const response = await axios.get(
      `${consumerBaseUrl}/user_profiles/${userProfileId}/devices`
    );
    logger.info(response.data);
    return response.data;
  } catch (error) {
    logger.error(error);
    throw error;
  }
};

export default userProfilesApi;
